var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "field",
        {
          attrs: {
            "size-class": "col-3 d-flex flex-column justify-content-center",
            transition: false,
          },
        },
        [
          _c("select-section", {
            attrs: {
              name: "deduction-type",
              options: _vm.deductionTypeOptions,
              disabled: _vm.isReadOnly,
            },
            model: {
              value: _vm.computedType,
              callback: function ($$v) {
                _vm.computedType = $$v
              },
              expression: "computedType",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          attrs: {
            "size-class": "col-2 d-flex flex-column justify-content-center",
            "container-class": "dollar-prepend",
          },
        },
        [
          _c("text-section", {
            attrs: {
              name: "deduction-amount",
              placeholder: "0.00",
              decimals: 2,
              disabled: _vm.isReadOnly,
              "class-name": "fe-num-field dollar",
              "allow-minus": "",
            },
            model: {
              value: _vm.computedAmount,
              callback: function ($$v) {
                _vm.computedAmount = _vm._n($$v)
              },
              expression: "computedAmount",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          attrs: {
            "size-class": "col-3 d-flex flex-column justify-content-center",
          },
        },
        [
          _c("date-section", {
            attrs: {
              name: "deduction-fundsReceivedDate",
              placeholder: "YYYY-MM-DD",
              "class-name": "date-format",
              "max-date": _vm.fundsReceivedDateMax,
              disabled: _vm.isReadOnly,
            },
            model: {
              value: _vm.computedFundsReceived,
              callback: function ($$v) {
                _vm.computedFundsReceived = $$v
              },
              expression: "computedFundsReceived",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "field",
        {
          attrs: {
            "size-class": "col-3 d-flex flex-column justify-content-center",
          },
        },
        [
          _vm.computedType === "other"
            ? _c("text-section", {
                attrs: {
                  name: "deduction-description",
                  placeholder: _vm.$t(
                    "direct-to-lender.commissions.deductions.deductionDescription"
                  ),
                },
                model: {
                  value: _vm.computedDescription,
                  callback: function ($$v) {
                    _vm.computedDescription = $$v
                  },
                  expression: "computedDescription",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isReadOnly
        ? _c(
            "field",
            {
              attrs: {
                "size-class": "col-1 d-flex flex-column justify-content-center",
              },
            },
            [
              _c(
                "inline-prompt",
                {
                  staticClass: "d-inline-block bold text-gray ml-2",
                  attrs: {
                    "action-type": "delete",
                    "confirmation-text": _vm.$t(
                      "direct-to-lender.commissions.deductions.confirmDelete"
                    ),
                  },
                  on: { accept: _vm.handleRemove },
                },
                [
                  _c("icon", {
                    attrs: {
                      name: "trash",
                      "icon-class": "text-danger clickable",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }